import React from 'react';
import { IProps as IBlockProps } from './FeatureVideoBlock.interface';
import { FeatureVideoBlock } from './FeatureVideoBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

interface IBlockInputProps {
    heading: string;
    videoDescription: string;
    image: any | null;
    videoSrc: 'youtube' | 'vimeo';
    videoId: string;
    transcript: string;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (
    input: IBlockInputProps
): IBlockProps => {

    const { heading, videoDescription, image, videoSrc, videoId, transcript, ...rest } = input;

    return {
        heading: heading,
        description: videoDescription,
        video: {
            url: `https://www.youtube.com/watch?v=${videoId}`,
            light: image?.defaultSrc || undefined,
        },
        transcript: transcript,
        transcriptButtonText: 'View Transcript',
        transcriptButtonTextOpen: 'Hide Transcript',
        ...rest
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (
    inputProps
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={FeatureVideoBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;